import useIsMobile from "./useIsMobile";
import useIsLandscape from "./useIsLandscape";

export default function useIsMobileLandscape(){
    const isMobile = useIsMobile()
    const isLandscape = useIsLandscape()
    const isMobileLandscape= isMobile && isLandscape
    return isMobileLandscape 
}